import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemuserinfoComponent } from './itemuserinfo.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ItemuserinfoComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports:[
    ItemuserinfoComponent
  ]
})
export class ItemuserinfoModule { }
